import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectOverdueActions } from './redux/selectors/overdueActions'; 
import {
  Grid,
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Modal,
  Card,
  //CardContent,
  CardActionArea,
  //Collapse,
  Fade
  //IconButton,
} from '@mui/material';
import SecurityReportData from './SecurityReportData';
import DynamicLabel from './DynamicLabel'; 
import { differenceInDays, parseISO } from 'date-fns';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import AlarmIcon from '@mui/icons-material/Alarm';
//import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import { ToggleButton, ToggleButtonGroup, Tooltip as MuiTooltip } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import GavelIcon from '@mui/icons-material/Gavel';

import RisksBySource from './risksBySource';


import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  LabelList,
} from 'recharts';


const CATEGORY_COLORS = [
  '#E3E3E3', // Light Gray
  '#B8C5D6', // Soft Blue Gray
  '#94A7BC', // Muted Blue
  '#7B8B99', // Steel Blue
  '#5D5D5D', // Medium Gray
  '#465362', // Dark Blue Gray
  '#D8E2DC', // Pale Green Gray
  '#E8E8E8', // Off White
  '#C4C4C4', // Silver Gray
  '#A5A5A5', // Medium Light Gray
  '#909090', // Neutral Gray
  '#BCB8A6', // Warm Gray
  '#9BA7B4', // Cool Gray
  '#8E9AAA', // Slate Gray
];

const COLORS = [
  '#94A7BC', // Muted Blue
  '#BCB8A6', // Warm Gray
  '#7B8B99', // Steel Blue
  '#D8E2DC', // Pale Green Gray
  '#B8C5D6', // Soft Blue Gray
  '#A5A5A5', // Medium Light Gray
  '#9BA7B4', // Cool Gray
  '#C4C4C4', // Silver Gray
  '#8E9AAA', // Slate Gray
  '#E3E3E3', // Light Gray
];

// Define risk priority colors consistent with AssessmentReport
const riskPriorityColors = {
  Critical: '#1A1A1A',    // Black
  High: '#993333',        // Red
  Significant: '#B94D4D', // Amber
  Moderate: '#D4AA7D',    // Light Orange
  Low: '#B8C2B7',         // Blue
  Negligible: '#D8D8D8',  // Green
  None: '#EBEBEB',        // Light Grey
};
const securityRiskColors = {
  Confidentiality: '#223B66',  // Deep, pronounced blue
  Integrity: '#B03E3A',        // Bold, pronounced red
  Availability: '#3F8E3F',     // Strong, pronounced green
};

// Helper function to convert camelCase to Title Case and normalize
const toTitleCase = (str) => {
  if (!str) return '';
  return str
    .trim() // Trim whitespace
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .replace(/^./, (char) => char.toUpperCase()) // Capitalize first character
    .trim();
};

const DashboardCard = ({ title, count, icon: Icon, children }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Card
        sx={{
          flex: 1,
          minHeight: 150,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1,
          mx: 1,
          bgcolor: '”#f0f2f5”', // Lighter, more luminous background
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          border: '1px solid #f0f0f0',
        }}
      >
        <CardActionArea onClick={handleOpen} sx={{ height: '100%', width: '100%', p: 1.5 }}>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100%' 
          }}>
            <Box 
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'rgba(243, 217, 216, 0.74)', // Lighter background for icon
                borderRadius: '50%',
                width: 40,
                height: 40,
                mb:1.5
              }}
            >
              <Icon fontSize="small" sx={{ color: 'text.secondary' }} />
            </Box>
            <Typography 
              variant="h5" 
              component="div" 
              sx={{ 
                textAlign: 'center',
                color: 'text.primary',
                mb: 1.5,
                fontWeight: 600 
              }}
            >
              {count}
            </Typography>
            <Typography 
              variant="subtitle1" 
              component="div"
              sx={{ 
                textAlign: 'center',
                color: 'text.secondary',
              }}
            >
              {title}
            </Typography>
          </Box>
        </CardActionArea>
      </Card>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: '#f7f9fc', // Match card background
              boxShadow: 24,
              p: 4,
              outline: 'none',
              maxHeight: '90vh',
              overflowY: 'auto',
              width: '90%',
              maxWidth: 800,
              borderRadius: 1,
            }}
          >
            {children || <Typography>No details available.</Typography>}
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

const RiskLandscape = () => {
  // Selectors to access necessary parts of the Redux state
  const models = useSelector((state) => state.risks.models);

  // Use the SecurityReportData component
  const { dataByModel, dataByCategory } = SecurityReportData();

  //console.log ('security data in RL', dataByModel)


  const overdueActions = useSelector(selectOverdueActions);

const [openOwnerModal, setOpenOwnerModal] = useState(false);
const [selectedOwnerRisks, setSelectedOwnerRisks] = useState([]);
const [selectedOwnerName, setSelectedOwnerName] = useState('');


const [sourceView, setSourceView] = useState('chart');
const handleSourceViewChange = (event, newView) => {
  if (newView) setSourceView(newView);
};


const riskCounts = useMemo(() => {
  const counts = {
    Critical: 0,
    High: 0,
    Significant: 0,
    Moderate: 0,
    Low: 0,
    Negligible: 0,
    None: 0,
  };

  // Aggregate risks from standard models
  Object.values(models).forEach((model) => {
    Object.entries(model.riskFormData || {}).forEach(([sectionName, sectionData]) => {
      Object.entries(sectionData.sectionRisks || {}).forEach(([category, risks]) => {
        if (Array.isArray(risks)) {
          risks.forEach((risk) => {
            const priority = toTitleCase((risk.priority || 'none').trim()); // Updated line
            if (counts.hasOwnProperty(priority)) {
              counts[priority] += 1;
            } else {
              // Handle unexpected priority by assigning to 'None'
              counts['None'] += 1;
              console.warn(`Unexpected priority "${priority}" encountered. Assigned to 'None'.`);
            }
          });
        }
      });
    });
  });

  // Aggregate security risks
  Object.entries(dataByModel).forEach(([modelUuid, modelData]) => {
    modelData.risks.forEach((risk) => {
      const priority = toTitleCase((risk.threat_level || 'none').trim()); // Updated line
      if (counts.hasOwnProperty(priority)) {
        counts[priority] += 1;
      } else {
        // Handle unexpected priority by assigning to 'None'
        counts['None'] += 1;
        console.warn(`Unexpected threat level "${priority}" encountered. Assigned to 'None'.`);
      }
    });
  });

  return counts;
}, [models, dataByModel]);
  // Transform riskCounts into an array suitable for BarChart
  const riskPriorityData = useMemo(() => {
    return Object.keys(riskCounts).map((key) => ({
      name: toTitleCase(key),
      count: riskCounts[key],
      risks: [], // Initialize an array to store risk names
    }));
  }, [riskCounts]);

  // Populate the risks for each priority
  useMemo(() => {
    // Clear existing risks
    riskPriorityData.forEach((data) => {
      data.risks = [];
    });

    // Add Model Risks
    Object.values(models).forEach((model) => {
      Object.entries(model.riskFormData || {}).forEach(([sectionName, sectionData]) => {
        Object.entries(sectionData.sectionRisks || {}).forEach(([category, risks]) => {
          if (Array.isArray(risks)) {
            risks.forEach((risk) => {
              const priority = toTitleCase(risk.priority || 'none');
              const riskName = risk.riskName || 'Unnamed Risk';
              const priorityData = riskPriorityData.find((data) => data.name === priority);
              if (priorityData) {
                priorityData.risks.push(riskName);
              } else {
                // Assign to 'None' if priority not found
                const noneData = riskPriorityData.find((data) => data.name === 'None');
                if (noneData) {
                  noneData.risks.push(riskName);
                }
              }
            });
          }
        });
      });
    });

    // Add Security Risks
    Object.entries(dataByModel).forEach(([modelUuid, modelData]) => {
      //const modelName = `Security Model ${modelUuid}`; // Placeholder for model name
      modelData.risks.forEach((risk) => {
        const priority = toTitleCase(risk.threat_level || 'none');
        const riskName = risk.risk_name || 'Unnamed Security Risk';
        const priorityData = riskPriorityData.find((data) => data.name === priority);
        if (priorityData) {
          priorityData.risks.push(riskName);
        } else {
          // Assign to 'None' if priority not found
          const noneData = riskPriorityData.find((data) => data.name === 'None');
          if (noneData) {
            noneData.risks.push(riskName);
          }
        }
      });
    });
  }, [models, dataByModel, riskPriorityData]);

  const assessmentStatusCounts = useMemo(() => {
    const counts = { Completed: 0, 'On-Going': 0, 'Not Started': 0 };

    Object.values(models).forEach((model) => {
      if (model.assessmentStatus === 'Completed') counts.Completed += 1;
      else if (model.assessmentStatus === 'On-Going') counts['On-Going'] += 1;
      else counts['Not Started'] += 1;
    });

    return counts;
  }, [models]);

  // Aggregate risks by source and category
  const risksBySource = useMemo(() => {
    const sourceData = {};

    // Process standard models
    Object.values(models).forEach((model) => {
      Object.entries(model.riskFormData || {}).forEach(([source, sectionData]) => {
        Object.entries(sectionData.sectionRisks || {}).forEach(([category, risks]) => {
          if (!sourceData[source]) {
            sourceData[source] = {};
          }
          const sanitizedCategory = toTitleCase(category.toLowerCase());
          sourceData[source][sanitizedCategory] = (sourceData[source][sanitizedCategory] || 0) + (Array.isArray(risks) ? risks.length : 0);
        });
      });
    });

    // Process security models using data from the custom hook
    Object.entries(dataByModel).forEach(([modelUuid, modelDetails]) => {
      modelDetails.risks.forEach((risk) => {
        const source = 'Security'; // Assuming all security risks belong to 'Security' source
        const category = risk.category
          ? toTitleCase(risk.category.trim().toLowerCase())
          : 'Uncategorized';
        if (!sourceData[source]) {
          sourceData[source] = {};
        }
        sourceData[source][category] = (sourceData[source][category] || 0) + 1;
      });
    });

    // Transform into array suitable for Recharts
    const chartData = Object.entries(sourceData).map(([source, categories]) => {
      return {
        source: toTitleCase(source),
        ...categories,
      };
    });

    return chartData;
  }, [models, dataByModel]);

  // Aggregate security risks by category for pie chart using data from the custom hook
  const securityRisksByCategory = useMemo(() => {
    const categoryMap = {};

    // Aggregate risks
    Object.entries(dataByCategory).forEach(([category, risks]) => {
      const sanitizedCategory = toTitleCase(category.toLowerCase());
      if (categoryMap[sanitizedCategory]) {
        categoryMap[sanitizedCategory] += Array.isArray(risks) ? risks.length : 0;
      } else {
        categoryMap[sanitizedCategory] = Array.isArray(risks) ? risks.length : 0;
      }
    });

    // Transform into array suitable for PieChart
    return Object.entries(categoryMap).map(([name, value]) => ({
      name,
      value,
    }));
  }, [dataByCategory]);
const uniqueCategories = useMemo(() => {
  const categorySet = new Set();

  // Categories from risksBySource data
  risksBySource.forEach((item) => {
    Object.keys(item).forEach((key) => {
      if (key !== 'source' && key !== 'total') {
        categorySet.add(key);
      }
    });
  });

  // Categories from securityRisksByCategory data
  securityRisksByCategory.forEach((item) => {
    categorySet.add(item.name);
  });

  // Convert Set to Array and sort
  return Array.from(categorySet).sort();
}, [risksBySource, securityRisksByCategory]);

// Map each unique category to a color
const categoryColorMap = useMemo(() => {
  return uniqueCategories.reduce((acc, category, index) => {
    acc[category] = CATEGORY_COLORS[index % CATEGORY_COLORS.length];
    return acc;
  }, {});
}, [uniqueCategories]);



  // Extract critical risks for the Critical Risks Table
  const criticalRisks = useMemo(() => {
    const criticalList = [];

    // Process standard models
    Object.values(models).forEach((model) => {
      const modelName = model.modelName; // Adjust based on actual model properties
      Object.entries(model.riskFormData || {}).forEach(([sectionName, sectionData]) => {
        Object.entries(sectionData.sectionRisks || {}).forEach(([category, risks]) => {
          if (Array.isArray(risks)) {
            risks.forEach((risk) => {
              if (risk.priority && risk.priority.toLowerCase() === 'critical') {
                criticalList.push({
                  id: risk.riskId || 'N/A',
                  name: risk.riskName,
                  modelName, // Added modelName
                  category: toTitleCase(category),
                  source: toTitleCase(sectionName),
                });
              }
            });
          }
        });
      });
    });

    // Process security models
    Object.entries(dataByModel).forEach(([modelUuid, modelData]) => {
      const model = models[modelUuid]; // Retrieve the model using modelUuid
      const modelName = model?.modelName; 
      modelData.risks.forEach((risk) => {
        if (risk.threat_level && risk.threat_level.toLowerCase() === 'critical') {
          criticalList.push({
            id: risk.id || 'N/A',
            name: risk.risk_name || 'Unnamed Security Risk',
            modelName, // Added modelName
            category: risk.category ? toTitleCase(risk.category.trim().toLowerCase()) : 'Uncategorized',
            source: 'Security',
          });
        }
      });
    });

    return criticalList;
  }, [models, dataByModel]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  // Slice criticalRisks based on pagination
  const paginatedCriticalRisks = useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    return criticalRisks.slice(start, end);
  }, [criticalRisks, page, rowsPerPage]);
  
  // Prepare data for the Assessment Status Pie Chart
  const assessmentStatusData = useMemo(() => [
    { name: 'Completed', value: assessmentStatusCounts.Completed },
    { name: 'On-Going', value: assessmentStatusCounts['On-Going'] },
    { name: 'Not Started', value: assessmentStatusCounts['Not Started'] },
  ], [assessmentStatusCounts]);

  const risksByOwnerData = useMemo(() => {
    const ownerCounts = {};
  
    // Process standard models
    Object.values(models).forEach((model) => {
      Object.entries(model.riskFormData || {}).forEach(([sectionName, sectionData]) => {
        Object.entries(sectionData.sectionRisks || {}).forEach(([category, risks]) => {
          if (Array.isArray(risks)) {
            risks.forEach((risk) => {
              const ownerName = risk.owner ? risk.owner.name : 'Unassigned';
              if (!ownerCounts[ownerName]) {
                ownerCounts[ownerName] = { count: 0, risks: [] };
              }
              ownerCounts[ownerName].count += 1;
              ownerCounts[ownerName].risks.push(risk.riskName || 'Unnamed Risk');
            });
          }
        });
      });
    });

  
    // Process security risks
    Object.entries(dataByModel).forEach(([modelUuid, modelData]) => {
      modelData.risks.forEach((risk) => {
        const ownerName = risk.owner_name || 'Unassigned';
        if (!ownerCounts[ownerName]) {
          ownerCounts[ownerName] = { count: 0, risks: [] };
        }
        ownerCounts[ownerName].count += 1;
        ownerCounts[ownerName].risks.push(risk.risk_name || 'Unnamed Security Risk');
      });
    });
  
    return Object.keys(ownerCounts).map((ownerName) => ({
      name: ownerName,
      count: ownerCounts[ownerName].count,
      risks: ownerCounts[ownerName].risks,
    }));
  }, [models, dataByModel]);


  const handleOwnerBarClick = (data) => {
    if (data && data.risks) {
      setSelectedOwnerRisks(data.risks);
      setSelectedOwnerName(data.name);
      setOpenOwnerModal(true);
    }
  };
  
  const handleCloseOwnerModal = () => {
    setOpenOwnerModal(false);
  };
  const CustomOwnerBarTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Paper sx={{ p: 2 }}>
          <Typography variant="subtitle1">{`Risks owned by ${label}`}</Typography>
          <ul>
            {Array.isArray(data.risks) && data.risks.length > 0 ? (
              data.risks.map((riskName, index) => (
                <li key={index}>{riskName}</li>
              ))
            ) : (
              <li>No risks available.</li>
            )}
          </ul>
        </Paper>
      );
    }
    return null;
  };

  // Prepare data for the Risks by Priority Pie Chart
  const risksByPriorityData = useMemo(() => riskPriorityData.map((item) => ({
    name: item.name,
    value: item.count,
  })), [riskPriorityData]);

  // Custom Tooltip Component for PieChart
  const CustomPieTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Paper sx={{ p: 1 }}>
          <Typography variant="subtitle2">{data.name}</Typography>
          <Typography variant="body2">Count: {data.value}</Typography>
        </Paper>
      );
    }
    return null;
  };

  // Custom Tooltip Component for BarChart
  const CustomBarTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Paper sx={{ p: 1 }}>
          <Typography variant="subtitle2">{label}</Typography>
          {payload.map((entry, index) => (
            <Typography key={index} variant="body2" style={{ color: entry.color }}>
              {entry.name}: {entry.value}
            </Typography>
          ))}
        </Paper>
      );
    }
    return null;
  };

  const calculateDaysOverdue = (dueDate) => {
    if (!dueDate) return null;
  
    const dueDateParsed = parseISO(dueDate);
    const now = new Date();
  
    const diffDays = differenceInDays(now, dueDateParsed);
  
    return diffDays > 0 ? diffDays : 0;
  };
  
  const complianceGaps = [];
  const complianceGapsCount = complianceGaps.length;


return (
  <Box sx={{ flexGrow: 1, padding: 3 }}>
   <Paper
    sx={{
      p: 3,
      mb: 4, // increased bottom margin to extend further
      boxShadow: 'none', // flattened appearance
      border: '1px solid #eee',
      borderRadius: '8px',
      bgcolor: '#fbfbfb',
    }}
  >
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          justifyContent: 'space-between',
          // bgcolor: '#fbfbfb', 
          // boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          // borderRadius: '8px'
        }}
      >
        <DashboardCard title="Critical Risks" count={criticalRisks.length} icon={PriorityHighIcon}>
          {criticalRisks.length > 0 ? (
            <>
              <TableContainer>
                <Table size="small" aria-label="critical risks table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Model Name</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Source</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedCriticalRisks.map((risk, index) => (
                      <TableRow key={`${risk.id}-${index}`}>
                        <TableCell>{risk.name}</TableCell>
                        <TableCell>{risk.modelName}</TableCell>
                        <TableCell>{risk.category}</TableCell>
                        <TableCell>{risk.source}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={criticalRisks.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
              />
            </>
          ) : (
            <Typography variant="body2">No critical risks found.</Typography>
          )}
        </DashboardCard>

        <DashboardCard title="Overdue Actions" count={overdueActions.length} icon={AlarmIcon}>
          {overdueActions.length > 0 ? (
            <TableContainer>
              <Table size="small" aria-label="overdue actions table">
                <TableHead>
                  <TableRow>
                    <TableCell>Control Name</TableCell>
                    <TableCell>Risk Name</TableCell>
                    <TableCell>Days Overdue</TableCell>
                    <TableCell>Model Name</TableCell>
                    <TableCell>Owner</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {overdueActions.map((action) => {
                    const daysOverdue = calculateDaysOverdue(action.dueDate);
                    return (
                      <TableRow key={action.id}>
                        <TableCell>{action.controlName}</TableCell>
                        <TableCell>{action.riskName}</TableCell>
                        <TableCell>{daysOverdue} days</TableCell>
                        <TableCell>{action.modelName}</TableCell>
                        <TableCell>{action.owner}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2">No overdue actions.</Typography>
          )}
        </DashboardCard>

        <DashboardCard title="Compliance Gaps" count={complianceGapsCount} icon={GavelIcon}>
          {complianceGapsCount > 0 ? (
            <Typography variant="body2">Compliance gaps details...</Typography>
          ) : (
            <Typography variant="body2">No compliance gaps found.</Typography>
          )}
        </DashboardCard>
       
      </Box>
      </Paper>

    {/* Risks by Source Section */}
    <Box sx={{
      p: 3,
      mt: 4,
      mb: 4,
      bgcolor: '#fbfbfb',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      borderRadius: '8px'
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" gutterBottom fontWeight="500" color="#333">
          Risks by Source
        </Typography>
        <ToggleButtonGroup
          value={sourceView}
          exclusive
          onChange={handleSourceViewChange}
          size="small"
          aria-label="View toggle"
        >
          <MuiTooltip title="Chart view">
            <ToggleButton value="chart" aria-label="chart view">
              <BarChartIcon />
            </ToggleButton>
          </MuiTooltip>
          <MuiTooltip title="Table view">
            <ToggleButton value="table" aria-label="table view">
              <TableChartIcon />
            </ToggleButton>
          </MuiTooltip>
        </ToggleButtonGroup>
      </Box>
      <Fade in={sourceView === 'chart'} timeout={300} unmountOnExit>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
          {/* existing chart Box code here */}
          <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
            <ResponsiveContainer width="100%" height={500}>
              <BarChart
                layout="vertical"
                data={risksBySource}
                margin={{ top: 15, right: 30, left: 20, bottom: 20 }}
                barGap={0}
                barSize={32}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#e0e0e0"
                  vertical={false}
                />
                <XAxis
                  type="number"
                  allowDecimals={false}
                  tickLine={false}
                  axisLine={{ stroke: '#d0d0d0' }}
                  tick={{ fontSize: 12, fill: '#555' }}
                />
                <YAxis
                  dataKey="source"
                  type="category"
                  width={140}
                  tick={{
                    fontSize: 14,
                    fontWeight: 500,
                    fill: '#333',
                    textAnchor: 'end',
                  }}
                  tickLine={false}
                  axisLine={{ stroke: '#d0d0d0' }}
                  tickFormatter={(value) => value.split('-')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')}
                />
                <Tooltip
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      return (
                        <div style={{
                          backgroundColor: '#fff',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <p style={{
                            margin: 0,
                            fontWeight: 'bold',
                            color: '#333',
                            marginBottom: '5px'
                          }}>{label.split('-')
                             .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                             .join(' ')}</p>
                          {payload.map((entry, index) => {
                            if (entry.value > 0) {
                              return (
                                <p key={`item-${index}`} style={{
                                  margin: 0,
                                  color: '#333',
                                  display: 'flex',
                                  justifyContent: 'space-between'
                                }}>
                                  <span style={{
                                    display: 'inline-block',
                                    width: '12px',
                                    height: '12px',
                                    backgroundColor: entry.color,
                                    marginRight: '5px',
                                    borderRadius: '2px'
                                  }}></span>
                                  <span style={{ marginRight: '10px' }}>
                                    {entry.dataKey.split('-')
                                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                      .join(' ')}:
                                  </span>
                                  <span style={{ fontWeight: 'bold' }}>{entry.value}</span>
                                </p>
                              );
                            }
                            return null;
                          })}
                        </div>
                      );
                    }
                    return null;
                  }}
                />
                {uniqueCategories.map((category, index) => (
                  <Bar
                    key={category}
                    dataKey={category}
                    stackId="a"
                    fill={categoryColorMap[category]}
                    animationDuration={600}
                    animationBegin={index * 100}
                    animationEasing="ease-out"
                  >
                    <LabelList
                      content={(props) => (
                        <DynamicLabel {...props} categoryName={category} />
                      )}
                    />
                  </Bar>
                ))}
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </Box>
      </Fade>
      <Fade in={sourceView === 'table'} timeout={300} unmountOnExit>
        <Box>
          <RisksBySource />
        </Box>
      </Fade>
    </Box>

    {/* Risks by Priority and Security Risks by Category */}
    <Grid container spacing={3} sx={{ mb: 4 }}>  {/* Added mb for vertical spacing */}
      <Grid item xs={12} md={6}>
        <Box sx={{ 
          p: 3, 
          height: '100%',
          bgcolor: '#fbfbfb', 
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <Typography variant="h6" gutterBottom fontWeight="500" color="#333">
            Risks by Priority
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={risksByPriorityData}
              margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
              <XAxis 
                dataKey="name" 
                interval={0} 
                angle={-45} 
                textAnchor="end" 
                height={70} 
                tickLine={false}
                axisLine={{ stroke: '#d0d0d0' }}
              />
              <YAxis 
                allowDecimals={false} 
                tickLine={false}
                axisLine={{ stroke: '#d0d0d0' }}
              />
              <Tooltip content={<CustomBarTooltip />} />
              <Bar dataKey="value">
                {risksByPriorityData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={riskPriorityColors[entry.name] || '#8884d8'}
                  />
                ))}
                <LabelList dataKey="value" position="top" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box sx={{ 
          p: 3, 
          height: '100%',
          bgcolor: '#fbfbfb', 
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <Typography variant="h6" gutterBottom fontWeight="500" color="#333">
            Security Risks by Category
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={securityRisksByCategory}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
                nameKey="name"
                label={({ name, percent }) =>
                  `${name} (${(percent * 100).toFixed(0)}%)`
                }
                labelLine={false}
              >
                {securityRisksByCategory.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={securityRiskColors[entry.name] || '#465362'}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomPieTooltip />} />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </Grid>
    </Grid>

    {/* Risks by Owner and Assessment Status Charts - Added vertical margin */}
    <Grid container spacing={3} sx={{ mt: 2, mb: 4 }}>
      <Grid item xs={12} md={6}>
        <Box sx={{ 
          p: 3, 
          height: '100%',
          bgcolor: '#fbfbfb', 
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <Typography variant="h6" gutterBottom fontWeight="500" color="#333">
            Risks by Owner
          </Typography>
          {risksByOwnerData && risksByOwnerData.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={risksByOwnerData}
                onClick={(data) => {
                  if (data && data.activePayload && data.activePayload.length > 0) {
                    handleOwnerBarClick(data.activePayload[0].payload);
                  }
                }}
                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
                <XAxis 
                  dataKey="name" 
                  angle={-45} 
                  textAnchor="end" 
                  interval={0} 
                  height={60} 
                  tickLine={false}
                  axisLine={{ stroke: '#d0d0d0' }}
                />
                <YAxis 
                  allowDecimals={false} 
                  tickLine={false}
                  axisLine={{ stroke: '#d0d0d0' }}
                />
                <Tooltip content={<CustomOwnerBarTooltip />} />
                <Bar dataKey="count" fill="#9BA7B4">
                  <LabelList dataKey="count" position="top" />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <Typography variant="body1">No data available for Risks by Owner.</Typography>
          )}
        </Box>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <Box sx={{ 
          p: 3, 
          height: '100%',
          bgcolor: '#fbfbfb', 
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          borderRadius: '8px'
        }}>
          <Typography variant="h6" gutterBottom fontWeight="500" color="#333">
            Assessments by Status
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={assessmentStatusData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
                label={({ name, percent }) =>
                  `${name} (${(percent * 100).toFixed(0)}%)`
                }
                labelLine={false}
              >
                {assessmentStatusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomPieTooltip />} />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </Grid>
    </Grid>
   
      
    {/* Owner Modal */}
    <Modal
      open={openOwnerModal}
      onClose={handleCloseOwnerModal}
      aria-labelledby="owner-modal-title"
      aria-describedby="owner-modal-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: 800,
        bgcolor: '#fbfbfb',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        borderRadius: '8px',
        p: 4,
        maxHeight: '90vh',
        overflowY: 'auto',
      }}>
        <Typography id="owner-modal-title" variant="h6" fontWeight="500" color="#333">
          Risks owned by {selectedOwnerName}
        </Typography>
        {Array.isArray(selectedOwnerRisks) && selectedOwnerRisks.length > 0 ? (
          <ul>
            {selectedOwnerRisks.map((riskName, index) => (
              <li key={index}>{riskName}</li>
            ))}
          </ul>
        ) : (
          <Typography variant="body1">No risks available for this owner.</Typography>
        )}
      </Box>
    </Modal>
  </Box>
);

};

export default RiskLandscape;
